(() => {
  'use strict';
  if (window.__lfnpAnalyticsCollector) return;
  window.__lfnpAnalyticsCollector = true;
  const key = 'lfnp:analytics-session';
  let identity = '';
  const requests = new Set();
  const events = new Set(['impression', 'open', 'dismiss', 'step', 'submit_attempt', 'subscribe_success', 'subscribe_error', 'code_copy', 'cta_click']);
  const label = /^[\p{L}\p{N} _.-]{1,100}$/u;
  const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;

  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  }
  function revoke() {
    identity = '';
    try { sessionStorage.removeItem(key); } catch (_) {}
    requests.forEach(controller => controller.abort());
    requests.clear();
  }
  function session() {
    if (identity) return identity;
    try { identity = sessionStorage.getItem(key) || ''; } catch (_) {}
    if (!uuid.test(identity)) identity = crypto.randomUUID();
    try { sessionStorage.setItem(key, identity); } catch (_) {}
    return identity;
  }
  function config() {
    try {
      const node = document.querySelector('[data-lfnp-analytics]');
      if (!node) return null;
      const value = JSON.parse(node.textContent);
      if (!value.endpoint || value.designMode || window.Shopify?.designMode) return null;
      if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') return null;
      if (new URL(location.href).searchParams.has('preview_theme_id')) return null;
      const endpoint = new URL(value.endpoint);
      if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password || endpoint.search || endpoint.hash || !endpoint.pathname.endsWith('/v1/events')) return null;
      return endpoint.href;
    } catch (_) { return null; }
  }
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) revoke(); });
  document.addEventListener('lfnp:event', event => {
    if (!allowed()) { revoke(); return; }
    const endpoint = config();
    const detail = event.detail;
    const eventName = detail?.event === 'audience_view' ? 'impression' : detail?.event;
    if (!endpoint || !detail || !events.has(eventName) || typeof detail.campaign !== 'string' || !label.test(detail.campaign)) return;
    if (!['modal', 'drawer', 'banner', 'embed'].includes(detail.format)) return;
    if (!['delay', 'scroll', 'manual', 'exit', 'idle', 'result'].includes(detail.trigger)) return;
    if (typeof crypto.randomUUID !== 'function') return;
    for (const field of ['experiment', 'variant', 'reason']) {
      if (detail[field] && (typeof detail[field] !== 'string' || !label.test(detail[field]))) return;
    }
    let campaign = detail.campaign;
    if (['returning', 'first_offer'].includes(detail.audience)) campaign += `.${detail.audience}`;
    if (!label.test(campaign)) return;
    const payload = { id: crypto.randomUUID(), session: session(), event: eventName, campaign,
      experiment: detail.experiment || '', variant: detail.variant || '', format: detail.format,
      trigger: detail.trigger, timestamp: Date.now(), reason: detail.reason || '', consent: true };
    const controller = new AbortController(); requests.add(controller);
    fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      signal: controller.signal, keepalive: true }).catch(() => {}).finally(() => requests.delete(controller));
  });
  function loadPrivacy() {
    if (!allowed()) revoke();
    if (!config()) return;
    if (window.Shopify?.customerPrivacy) { if (!allowed()) revoke(); return; }
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { if (!allowed()) revoke(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadPrivacy, { once: true });
  else loadPrivacy();
})();
